import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { getBikeTechData } from './bikeThunks';
import { clearBikeKey } from '../../sell/sellKeys';
const SLICE_NAME = 'techData';

export const techDataSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBikeTechData(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeTechData });
        builder.addCase(clearBikeKey, () => commonInitialState);
    },
});

export const { clearBikeTechData } = techDataSlice.actions;

export const selectBikeTechDataLoading = (state) =>
    state.bikeData.techData.isLoading;

export const techData = techDataSlice.reducer;
